export const splitRange = (range: Pair<number, number>, size: number): Pair<number, number>[] => {
    const step = Math.ceil(Math.abs((range.right - range.left) / size));
    const result: Pair<number, number>[] = [];
    for (let i = 0; i < size; i++) {
        result.push({ left: range.left + i * step, right: Math.min(range.left + (i + 1) * step, range.right) });
    }
    return result;
};
